import React from 'react';
import './medias.css'; 

function Medias() {

    return (
        <div className="container">
            <div className="display_all_articles">
                <div className="main_div_articles">
                    <img src="https://paulmarechal.xyz/assets/images_articles/mac4ever.webp" alt="Capture d'écran d'un article Mac4Ever sur catacombes.xyz"/>
                    <h3>Mac4Ever</h3>
                    <p>
                        Site de référence pour les passionnés de tech et d’univers Apple, <strong>Mac4Ever</strong> a consacré un article à mon projet de visite virtuelle des catacombes interdites de Paris. Ils mettent en avant l’utilisation du LiDAR de l’iPhone et d’outils 3D pour créer une immersion inédite.
                    </p>
                    <a href="https://www.mac4ever.com/divers/185476-plongee-virtuelle-dans-les-catacombes-interdites-de-paris" target="_blank" rel="noopener noreferrer">Visiter</a>
                </div>

                <div className="main_div_articles">
                    <img src="https://paulmarechal.xyz/assets/images_articles/numerama.webp" alt="Capture d'écran d'un article Numérama sur catacombes.xyz"/>
                    <h3>Numerama</h3>
                    <p>
                        Média en ligne spécialisé dans l’innovation, le numérique et la culture tech, <strong>Numerama</strong> présente mon site comme une nouvelle façon d’explorer les catacombes parisiennes, grâce à la 3D et la réalité virtuelle. Un projet qui mêle histoire, patrimoine et technologie immersive.
                    </p>
                    <a href="https://www.numerama.com/tech/1266844-visitez-les-catacombes-de-paris-en-3d-et-en-vr-avec-ce-site.html" target="_blank" rel="noopener noreferrer">Visiter</a>
                </div>

                <div className="main_div_articles">
                    <img src="https://paulmarechal.xyz/assets/images_articles/parisZigZag.webp" alt="Capture d'écran d'un article Paris Zig Zag sur catacombes.xyz"/>
                    <h3>Paris ZigZag</h3>
                    <p>
                        <strong>Paris ZigZag</strong>, média connu pour ses explorations insolites de la capitale, met en avant mon initiative comme une plongée unique dans le patrimoine caché de Paris. Ils évoquent l’approche originale de mon projet et son aspect culturel autour des catacombes méconnues.
                    </p>
                    <a href="https://www.pariszigzag.fr/insolite/histoire-insolite-paris/une-visite-inedite-dans-les-catacombes-patrimoine-meconnu-des-souterrains-parisiens" target="_blank" rel="noopener noreferrer">Visiter</a>
                </div>
            </div>

            
        </div>
    );
}

export default Medias;
